"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Data = exports.DataType = void 0;
var Helpers_1 = require("./Helpers");
var DataType;
(function (DataType) {
    DataType[DataType["I64"] = 1] = "I64";
    DataType[DataType["Byte"] = 2] = "Byte";
    DataType[DataType["ByteArray"] = 3] = "ByteArray";
    DataType[DataType["U32"] = 4] = "U32";
    DataType[DataType["U64"] = 5] = "U64";
    DataType[DataType["String"] = 6] = "String";
    DataType[DataType["Hash"] = 7] = "Hash";
    DataType[DataType["Lock"] = 8] = "Lock";
    DataType[DataType["Signature"] = 9] = "Signature";
    DataType[DataType["PublicKey"] = 10] = "PublicKey";
    DataType[DataType["CollectionArray"] = 11] = "CollectionArray";
    DataType[DataType["CollectionDict"] = 12] = "CollectionDict";
    DataType[DataType["CollectionList"] = 13] = "CollectionList";
})(DataType = exports.DataType || (exports.DataType = {}));
var Data = /** @class */ (function () {
    function Data(identifier) {
        this.identifier = identifier;
    }
    Data.prototype.getSize = function () {
        return Helpers_1.Byte.getSize();
    };
    Data.prototype.toJson = function () {
        return {};
    };
    Data.prototype.write = function (buffer, offset) {
        return buffer.writeUInt8(this.identifier, offset);
    };
    return Data;
}());
exports.Data = Data;
//# sourceMappingURL=Data.js.map